var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"body-class":"pb-50"}},[_c('h6',[_vm._v(_vm._s(_vm.title))]),_c('h2',{staticClass:"font-weight-bolder mb-1"},[_vm._v(" "+_vm._s(_vm.kFormatter(_vm.data))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }